import {
  CasesValue,
  TCaseFieldKeys,
  TCaseObjectKeys,
} from "../../../services/api/instances/casesApi/types";
import { CASE_FIELD_ROWS, CASE_FIELD_TOOLTIP } from "../constants";
import { TCaseEntityMode } from "../redux/types";
import { TCaseBlock, TCaseField, TCaseLocalState } from "../types";

export const aggregateCaseLocalValue = (
  caseObj: CasesValue,
  dirtyFields: Record<string, boolean> = {},
  entityMode: TCaseEntityMode,
): TCaseLocalState => {
  const object =
    entityMode === "case" ? caseObj.case_object : caseObj.agent_harness;
  const result = Object.entries(object).map(
    ([blockKey, blockField]): TCaseBlock => {
      const fields = Object.entries(
        blockField as Record<string, string | boolean>,
      ).map(([fieldKey, fieldValue]): TCaseField => {
        const path = `${blockKey}.${fieldKey}`;
        return {
          label: fieldKey as TCaseFieldKeys,
          value: fieldValue,
          needSave: dirtyFields[path] ?? false,
          path: `${path}.${fieldKey}`,
          tooltip:
            entityMode === "case"
              ? CASE_FIELD_TOOLTIP[fieldKey as TCaseFieldKeys]
              : "",
          inputRows:
            entityMode === "case"
              ? CASE_FIELD_ROWS[fieldKey as TCaseFieldKeys]
              : 2,
        };
      });
      return {
        blockTitle: blockKey as TCaseObjectKeys,
        fields,
        tooltip:
          entityMode === "case"
            ? CASE_FIELD_TOOLTIP[blockKey as TCaseFieldKeys]
            : "",
      };
    },
  );
  return result;
};
